import {Notification, NotificationLevel} from '../notification/notification';

type ErrorLevel = 'INFO' | 'WARN' | 'ERROR';

export class HttpError {

  static fromDto(dto: HttpError): HttpError {
    return new HttpError(
      dto.id,
      dto.status,
      dto.message,
      dto.level,
    );
  }

  constructor(public id: string,
              public status: number,
              public message: string,
              public level: ErrorLevel,
  ) {
  }

  isValid(): boolean {
    return !!this.id && !!this.status && !!this.message && !!this.level;
  }

  isError(): boolean {
    return 'ERROR' === this.level;
  }

  toNotification(): Notification {
    return new Notification(
      this.level.toLowerCase() as NotificationLevel,
      this.message,
      this.isError() ? this.id : null,
    );
  }
}
